import React from 'react';
import './speech-builder.css';
import { SpeechOption } from './speech-option';
import { Paragraph } from '../../../components/paragraph';
import { shuffleArray } from '../../../helpers/active-game';

const SpeechBuilder = props => {
    const {
        userSpeech,
        setUserSpeech,
        setAudioObject,
        activeSpeechStep,
        activeSpeechOptions,
        setActiveSpeechStep,
        loadAudio,
    } = props;

    const addToSpeech = (option, speechStep) => {
        const audioID = option.mp3Filename.substring(
            0,
            option.mp3Filename.length - 4,
        );
        setUserSpeech({
            ...userSpeech,
            [speechStep]: option,
        });
        setAudioObject(audioObject => ({
            ...audioObject,
            [speechStep]: audioID,
        }));
        loadAudio(audioID);
        setActiveSpeechStep(activeSpeechStep + 1);
        shuffleArray(activeSpeechOptions);
    };

    const chosenSegmentForCurrentStep =
        userSpeech[activeSpeechStep] !== null
            ? userSpeech[activeSpeechStep]
            : null;

    const remainingOptionsIndexMax =
        chosenSegmentForCurrentStep !== null ? 1 : 2;

    return (
        <div className="speech-builder">
            {chosenSegmentForCurrentStep !== null && activeSpeechStep < 5 && (
                <SpeechOption
                    key={
                        activeSpeechStep +
                        chosenSegmentForCurrentStep.mp3Filename
                    }
                    option={chosenSegmentForCurrentStep}
                    onClick={() =>
                        addToSpeech(
                            chosenSegmentForCurrentStep,
                            activeSpeechStep,
                        )
                    }
                />
            )}
            {activeSpeechStep < 5 ? (
                activeSpeechOptions.map((option, i) => {
                    if (i > remainingOptionsIndexMax) {
                        return null;
                    }
                    return (
                        <SpeechOption
                            key={activeSpeechStep + option.mp3Filename}
                            option={option}
                            onClick={() =>
                                addToSpeech(option, activeSpeechStep)
                            }
                        />
                    );
                })
            ) : (
                <div className="speech-builder__speech-complete">
                    <Paragraph size="large" withSpacing={false}>
                        {' '}
                        Speech Complete
                    </Paragraph>
                </div>
            )}
        </div>
    );
};

export { SpeechBuilder };
